import React, { useEffect, useMemo, useState } from 'react';
import ColorTitleDialog from '../../Dialog/ColorTitleDialog';
import { Grid } from '@material-ui/core';
import { useLang } from '../../../util/lang';
import { NavigateBeforeOutlined, NavigateNextOutlined } from '@material-ui/icons';
import './TrioDimDialog.css';
import { getWebAbsPath } from '../../../util/path';

const NUM_OF_SLIDES = 4; // refer to /img/prescriptionNotes/triodim_force_pic0_400x280.jpg..., currently has 4 slides in total

const IconButton = ({ icon, onClick, hide = false }) => {
    return (
        <div onClick={onClick} className="round-icon-wrapper" style={{ visibility: hide ? 'hidden' : '' }}>
            {icon ? icon : null}
        </div>
    );
};

const SlidePhotoCard = ({ imgSrc }) => {
    return (
        <Grid className="slide-photo-card">
            <img src={imgSrc} />
        </Grid>
    );
};

const TrioDimDialog = ({ open, handleClose }) => {
    const getLang = useLang();
    const [currentIndex, setCurrentIndex] = useState(0);

    const SelectedImg = useMemo(() => {
        return getWebAbsPath(`/img/prescriptionNotes/triodim_force_pic${currentIndex}_400x280.jpg`);
    }, [currentIndex, getWebAbsPath]);

    useEffect(() => {
        return () => {
            setCurrentIndex(0);
        };
    }, []);

    const onClose = () => {
        handleClose();
        setTimeout(() => {
            setCurrentIndex(0);
        }, 800); // Delay in milliseconds
    };

    return (
        <ColorTitleDialog
            open={open}
            handleClose={onClose}
            title={`TrioDim Force™ ${getLang('@global.const.Technology')}`}
            showCloseBtn
            closeBtnStyle={{
                paddingLeft: 30,
                paddingRight: 30,
            }}
            actionStyle={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
            }}
        >
            <Grid container spacing={4}>
                <Grid item xs={6}>
                    <p style={{ lineHeight: 1.8 }}>
                        <strong>{`The TrioDim Force™ ${getLang('@global.const.technology')} `}</strong>
                        <span>{getLang('@NewPatient.prescriptionNotes.trioDimForceDescription')}</span>
                    </p>
                </Grid>

                <Grid
                    item
                    xs={6}
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <IconButton
                        icon={<NavigateBeforeOutlined />}
                        onClick={() => setCurrentIndex(currentIndex - 1)}
                        hide={currentIndex === 0}
                    />
                    <Grid style={{ marginLeft: 16, marginRight: 16 }}>
                        <SlidePhotoCard imgSrc={SelectedImg} />
                    </Grid>
                    <IconButton
                        icon={<NavigateNextOutlined />}
                        onClick={() => setCurrentIndex(currentIndex + 1)}
                        hide={currentIndex === NUM_OF_SLIDES - 1}
                    />
                </Grid>
            </Grid>
        </ColorTitleDialog>
    );
};

export default TrioDimDialog;
